import axios from "axios";

// Use environment variable or fallback to localhost
const API_URL =
  import.meta.env.VITE_CRM_API_URL || "https://dashboard.lono.co.in/api/attendance";

// Create a reusable axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    // Retrieve the token using the key defined in AuthContext.jsx
    const token = localStorage.getItem("token"); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const attendanceAPI = {
  // Clock In
  clockIn: async (staffId) => {
    try {
      const response = await api.post(`/login/${staffId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Clock Out
  clockOut: async (staffId) => {
    try {
      const response = await api.post(`/logout/${staffId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Take a Break (Break Start)
  takeBreak: async (staffId) => {
    try {
      const response = await api.post(`/staff/${staffId}/break-in`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // End Break
  endBreak: async (staffId) => {
    try {
      const response = await api.post(`/staff/${staffId}/break-out`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get Staff Workfolio
  getWorkfolio: async (staffId, year, month) => {
    try {
      const params = {};
      if (year) params.year = year;
      if (month) params.month = month;

      const response = await api.get(`/staff/${staffId}/workfolio`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  getAttendance: async (staffId) => {
    try {
      const response = await api.get(`/staff/${staffId}/attendance`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get Daily Status
  getDailyStatus: async (staffId, date) => {
    try {
      const response = await api.get(`/staff/${staffId}/status`, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  getCurrentStaffStatus: async (staffId) => {
    try {
      const response = await api.get(`/staff/${staffId}/status`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  // Create Leave Request
  createLeaveRequest: async (staffId, leaveData) => {
    try {
      const response = await api.post(`/leave/${staffId}`, leaveData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  // Get Staff Leaves
  getStaffLeaves: async (staffId) => {
    try {
      const response = await api.get(`/staff/${staffId}/leaves`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Approve Leave Request
  approveLeaveRequest: async (leaveId) => {
    try {
      const response = await api.post(`/leave/${leaveId}/approve`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Reject Leave Request
  rejectLeaveRequest: async (leaveId) => {
    try {
      const response = await api.post(`/leave/${leaveId}/reject`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};
